import { RefreshCw } from 'lucide-react';
import { t } from '../i18n';
import { useVersionNueva } from '../lib/version-panel';

/** Aviso fijo arriba cuando hay una versión nueva del panel: recargar trae los arreglos ya desplegados. */
export function AvisoVersionNueva() {
  const nueva = useVersionNueva();
  if (!nueva) return null;
  return (
    <div role="status" className="fixed left-1/2 top-3 z-[100] flex -translate-x-1/2 items-center gap-3 rounded-full bg-oficina-elevada px-4 py-2 text-o-texto text-oficina-texto shadow-o-flota ring-1 ring-white/10">
      <span>{t('oficinaV2.versionNueva')}</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="inline-flex items-center gap-1.5 rounded-full bg-oficina-acento px-3 py-1 font-medium text-oficina-acento-tinta hover:bg-oficina-acento-hover"
      >
        <RefreshCw className="h-3.5 w-3.5" aria-hidden />
        {t('oficinaV2.recargar')}
      </button>
    </div>
  );
}
